import { render, staticRenderFns } from "./_DuplicateOrderDialog.vue?vue&type=template&id=6053fbf5&scoped=true&"
import script from "./_DuplicateOrderDialog.vue?vue&type=script&lang=js&"
export * from "./_DuplicateOrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./_DuplicateOrderDialog.vue?vue&type=style&index=0&id=6053fbf5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6053fbf5",
  null
  
)

export default component.exports